import axios from 'axios'

// Deja en la consola del navegador el trace_id que el backend devuelve cuando
// algo falla, para poder hilar lo que vio el usuario con las lineas del
// laravel.log. Envuelve solo las llamadas de auditorias: no toca la config
// global de axios, asi que ningun otro modulo se ve afectado.
function conTraza (nombre, promesa) {
  return promesa.then(
    respuesta => {
      const data = respuesta.data || {}
      if (data.success === false) {
        console.warn('[auditorias] ' + nombre + ': el backend no devolvio datos', {
          trace_id: data.trace_id || null
        })
      }
      return respuesta
    },
    error => {
      const respuesta = error.response || {}
      const data = respuesta.data || {}
      console.error('[auditorias] ' + nombre + ': la peticion fallo', {
        status: respuesta.status || null,
        trace_id: data.trace_id || null,
        error: error.message
      })
      return Promise.reject(error)
    }
  )
}

export default {
  listar () {
    return conTraza('listar', axios.get('/auditorias'))
  },
  obtenerDetalle (id) {
    return conTraza('obtenerDetalle(' + id + ')', axios.get('/auditorias/' + id + '/detalle'))
  },
  intervenciones () {
    return conTraza('intervenciones', axios.get('/auditorias/intervenciones'))
  }
}
